import type { BannerDisplayOptions } from './bannerDisplay';
import { bannerOptionsToSearch } from './bannerDisplay';

const PENDING_INVITE_KEY = 'yp_pending_invite';

export function normalizeInviteCode(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const code = raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (code.length < 2 || code.length > 64) return null;
  return code;
}

/** Read invite from current URL query and persist it; strip param from address bar. */
export function captureInviteFromUrl(): string | null {
  try {
    const url = new URL(window.location.href);
    const fromQuery = normalizeInviteCode(url.searchParams.get('invite'));
    if (fromQuery) {
      sessionStorage.setItem(PENDING_INVITE_KEY, fromQuery);
      url.searchParams.delete('invite');
      const next = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState({}, '', next);
      return fromQuery;
    }
  } catch {
    /* ignore */
  }
  return peekPendingInvite();
}

export function peekPendingInvite(): string | null {
  try {
    return normalizeInviteCode(sessionStorage.getItem(PENDING_INVITE_KEY));
  } catch {
    return null;
  }
}

export function clearPendingInvite(): void {
  try {
    sessionStorage.removeItem(PENDING_INVITE_KEY);
  } catch {
    /* ignore */
  }
}

export function bannerUrlForCode(
  code: string,
  portalBaseUrl?: string,
  options?: BannerDisplayOptions,
): string {
  const normalized = normalizeInviteCode(code) ?? code.trim().toUpperCase();
  let url: string;
  if (portalBaseUrl) {
    url = `${portalBaseUrl.replace(/\/$/, '')}/banner/${encodeURIComponent(normalized)}`;
  } else {
    const base = (import.meta.env.VITE_APP_BASE_PATH || '/user').replace(/\/$/, '');
    url = `${window.location.origin}${base}/banner/${encodeURIComponent(normalized)}`;
  }
  if (!options) return url;
  const qs = bannerOptionsToSearch(options);
  return qs ? `${url}?${qs}` : url;
}
